/**
 * Maps AI-generated content types to database-safe values
 * AI returns display names (e.g., "Show & Tell"), database uses slugs (e.g., "show-and-tell")
 */

export const VALID_CONTENT_TYPES = [
  'video', 'article', 'guide', 'template', 'story', 'other',
  'tool', 'tutorial', 'playbook', 'tips', 'demo', 'checklist',
  'framework', 'case-study', 'research', 'show-and-tell'
] as const;

export type ContentType = typeof VALID_CONTENT_TYPES[number];

// Map from AI display names to database values
const AI_TO_DB_MAP: Record<string, ContentType> = {
  'show & tell': 'show-and-tell',
  'show and tell': 'show-and-tell',
  'case study': 'case-study',
  'tutorial': 'tutorial',
  'guide': 'guide',
  'template': 'template',
  'playbook': 'playbook',
  'tips': 'tips',
  'video': 'video',
  'article': 'article',
  'tool': 'tool',
  'demo': 'demo',
  'checklist': 'checklist',
  'framework': 'framework',
  'research': 'research',
  'story': 'story',
  'other': 'other'
};

// Map from database values to display names
const DB_TO_DISPLAY_MAP: Record<ContentType, string> = {
  'show-and-tell': 'Show & Tell',
  'case-study': 'Case Study',
  'tutorial': 'Tutorial',
  'guide': 'Guide',
  'template': 'Template',
  'playbook': 'Playbook',
  'tips': 'Tips',
  'video': 'Video',
  'article': 'Article',
  'tool': 'Tool',
  'demo': 'Demo',
  'checklist': 'Checklist',
  'framework': 'Framework',
  'research': 'Research',
  'story': 'Story',
  'other': 'Other'
};

export function mapAITypeToDbType(aiType: string | undefined | null): ContentType {
  if (!aiType) return 'article';
  const normalized = aiType.toLowerCase().trim();
  return AI_TO_DB_MAP[normalized] || 'other';
}

export function mapDbTypeToDisplay(dbType: string): string {
  return DB_TO_DISPLAY_MAP[dbType as ContentType] || dbType;
}

export function isValidContentType(type: string): type is ContentType {
  return VALID_CONTENT_TYPES.includes(type as ContentType);
}
